import Button from './Button';
import Modal from './Modal';

type UnsavedChangesModalProps = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const UnsavedChangesModal = ({ isOpen, onConfirm, onCancel }: UnsavedChangesModalProps) => {
  return (
    <Modal
      open={isOpen}
      onOpenChange={(open) => !open && onCancel()}
      className="w-full max-w-md rounded-lg"
      hideHeader
    >
      <div className="pt-3">
        <h3 className="text-lg mb-2 font-semibold text-neutral-100">Wait a minute</h3>
        <p className="text-body-lg-desktop text-neutral-100">
          Are you sure you want to leave this page? All unsaved changes will be lost.
        </p>
      </div>

      <div className="flex justify-end gap-2 py-6">
        <Button preset="tertiary" onClick={onCancel}>
          Cancel
        </Button>
        <Button preset="warning" onClick={onConfirm}>
          Leave Page
        </Button>
      </div>
    </Modal>
  );
};
